import { render, staticRenderFns } from "./dashPrincipal.vue?vue&type=template&id=34ea2fca&"
import script from "./dashPrincipal.vue?vue&type=script&lang=ts&"
export * from "./dashPrincipal.vue?vue&type=script&lang=ts&"
import style0 from "./dashPrincipal.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports